import React from 'react';

import "react-responsive-carousel/lib/styles/carousel.min.css"; // requires a loader
import { Carousel } from 'react-responsive-carousel';


import '../../style/about.css';

import Note from '../../components/note.js';
import Header from '../../components/header.js';
import Footer from '../../components/footer';

import PageTop from '../../components/pageTop';

import Slider from '../../components/about_slider';

import Alert from '../../components/alert';

// Images
import RAImage1 from '../../assets/img/news/gloria_anthony.jpg';



function NewsPage(){
    window.scrollTo(0, 0);

    return(
        <div>
            {/* <Note/> */}
            <Alert/>
            <Header/>
            <PageTop/>
            <div className="page_title">
               <label>News</label>
            </div>
            <div class="about_body" style={{lineHeight: '40px', marginTop: '-200px'}}>

                    <div>
                        <img src={RAImage1}style={{width: "300px"}} />
                    </div>



                <div class="">
                     <div>
                        <div class="title">
                            <label> St. Vincent Co-operative Bank Ltd. Announces Appointment of New Chief Executive Officer – Mrs. Gloria Anthony</label>
                            <div></div>
                        </div>
                        <p>
                       
Kingstown, St. Vincent – November 21st, 2025– The Board of Directors of the St. Vincent Co-operative Bank Ltd. is pleased to announce the appointment of Mrs. Gloria Anthony as the Bank’s new Chief Executive Officer (CEO).
Mrs. Anthony brings to the role over 30 years of experience in banking and finance, with a proven record of leadership, innovation, and commitment to service excellence. 
Throughout her distinguished career, Mrs. Anthony has acquired extensive expertise in business development, leadership, strategic planning, retail banking, and commercial lending. Her work has been instrumental in helping small and mid-sized enterprises (SMEs) navigate challenges, enhance their financial performance, and achieve sustainable growth.
</p>
<p>
A career banker, Mrs. Anthony was an executive of Republic Financial Holdings Limited, the largest banking Group in the Caribbean for several years. From 2015 to 2018, she served as the Managing Director of Republic Bank Suriname N.V. where she spearheaded the Bank’s growth to the top three position in the financial industry in Suriname solidifying the Group’s presence in the North American market. Prior to this, she led the Group’s Commercial and Retail Banking operations in Trinidad and Tobago, with responsibility for commercial business banking, retail loans, residential and commercial mortgages, credit card and call center operations. She also played a significant role in the Group’s acquisition and project management activities. 
Mrs. Anthony has served on several boards including the Bank of St Lucia, the Caribbean Association of Banks, the Bankers’ Association of Suriname, Securicor Trinidad and Tobago Ltd, and the Association for Human Resource Information Management. 
</p>
<p>
She holds an associate degree in banking from the IFS School of Finance UK
and a master’s in business administration from Heriot Watt University, Edinburgh
UK.
</p>
<p>
With a strong passion for service excellence and building high performance teams, Mrs. Anthony is poised to lead St. Vincent Co-operative Bank Ltd. into a new era of growth, strengthening the Bank’s position as a trusted partner in the financial sector .
The Board of Directors, Management, and Staff of St. Vincent Co-operative Bank Ltd. extend their warmest congratulations to Mrs. Gloria Anthony on her appointment.

                        </p>
                     </div>         
                </div>

            </div>
            <Footer/>
        </div>
    )
}

export default NewsPage;